<template>
  <div class="rule-table-wrapper">
    <div class="rule-table-container">
      <div class="rule-table">
    <!--头部-->
    <el-form>
      <el-row
        justify="center"
        class="first-row"
        v-for="(headerItem,j) in SelfRuleData.slice(0,1)"
        :key="j + 'first'"
      >
        <el-col
          class="col-box isfirst-row header one-col center"
          :span="getColNumber()"
        >
          {{$t('Home.accountType')}}
        </el-col>
        <el-col
          class="col-box isfirst-row header center"
          v-for="(headerItem,k) in headerItem.symbolGroup"
          :key="k"
          :span="getColNumber()"
        >
          <div class="center">
            {{getHeaderItem(headerItem)}}
          </div>
        </el-col>
      </el-row>
      <el-row
        justify="center"
        class="second-row"
        v-for="(item,index) in SelfRuleData"
        :key="index"
      >
        <el-col
          class="col-box account-type-cell"
          :span="24"
        >{{item.mt4GroupNamme}}
        </el-col>
        <el-col
          class="col-box data-cell"
          v-for="(colItem,i) in item.symbolGroup"
          :key="i"
          :span="getColNumber()"
          :data-label="colItem.name"
        >
          <el-form-item class="form-item">
            <span v-if="isReadonly || colItem.max == -1">
              {{getReadonlyText(colItem)}}
              <span>{{getSuffix(colItem.suffix,colItem)}}</span>
            </span>
            <div class="input-box pr" v-else>
              <el-input
                maxLength="6"
                :placeholder="getPlaceholder(colItem.max,index,i)"
                v-model="colItem.value"
                @blur.native="blurHandle(colItem, index, i)"
                :class="validateClass(colItem,index,i)"
              ></el-input>
              <span class="suffix">{{getSuffix(colItem.suffix,colItem)}}</span>
              <div v-if="colItem.validateError" class="error-message">{{getErrorMessage(colItem,index)}}</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="!ruleData.length" class="no-data">{{$t('root.noData')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { maxOneFloatOrNone } from '@/utils/validate'
  import { getRuleValidateFlag,getHandleRuleData } from '@/utils/common'
  export default {
    name: 'RuleTable',
    props: {
      ruleData: {
        type: Array,
        default: [
          /*{
            accountNamme: 'STD',
            symbolGroup: [
              {
                name: 'Forex',
                value: 5,
                max: 5,
                suffix: '$/lot',
                tips: '≤5'
              },
              {
                name: 'GOLD',
                value: 3,
                max: 3,
                suffix: 'pips/lot',
                tips: '≤3'
              },
              {
                name: 'SUVKER',
                value: 2,
                max: 2,
                suffix: 'pips/lot',
                tips: '≤2'
              },
              {
                name: 'Oil',
                value: 0.2,
                max: 0.2,
                suffix: '$/lot',
                tips: '≤0.2'
              },
              {
                name: 'INDEX',
                value: 1,
                max: 1,
                suffix: '$/lot',
                tips: '≤1'
              }
            ]
          },*/
        ]
      },
      isReadonly:{
        type: Boolean,
        default: false,
      },
      fatherRuleData:{
        type: Array,
        default(){
          return []
        }
      },
    },
    data() {
      return {
        SelfRuleData: JSON.parse(JSON.stringify(this.ruleData)),
      };
    },
    watch:{
      ruleData(newVal){
        this.SelfRuleData = JSON.parse(JSON.stringify(newVal.slice(0)));
      },
    },
    methods: {
      // 重置所有验证状态
      resetValidateStatus(){
        if(!this.SelfRuleData || !this.SelfRuleData.length){
          return;
        }
        for (let i = 0; i < this.SelfRuleData.length; i++) {
          for (let j = 0; j < this.SelfRuleData[i].symbolGroup.length; j++) {
            this.SelfRuleData[i].symbolGroup[j].validateError = false;
            this.SelfRuleData[i].symbolGroup[j].validateErrorType = '';
            this.SelfRuleData[i].symbolGroup[j].maxValue = null;
          }
        }
        // 强制重新渲染
        this.$forceUpdate();
      },
      clearCom(dataList){
        if(!dataList.length){
          return;
        }
        for (let i = 0; i < dataList.length; i++) {
          for (let j = 0; j < dataList[i].symbolGroup.length; j++) {
            dataList[i].symbolGroup[j].value = '';
          }
        }
      },
      getSuffix(suffix,colItem){
        if(colItem.max == -1){
          return '';
        }
        if(suffix === 1){
          return '$' + '/lot';
        }else if(suffix === 3){
          return 'pips' + '/lot'
        }if(suffix === 4){
          return '%';
        }
      },
      getColNumber(){
        /*let colNumber = 0;
        switch (this.SelfRuleData[0].symbolGroup.length) {
          case 4:
            colNumber = 5;
            break;
          case 4:
            colNumber = 4;
            break;
        }*/
        return 7;
      },
      getHeaderItem(headerItem){
        return headerItem.name;
      },
      getColItem(colItem){
        return colItem.value;
      },
      getPlaceholder(max,index,i){
        // max value 都是-1就显示/
        if(max == -1){
          console.log(max);
          return '/';
        }
        // 修改代理的佣金规则不需要显示<=
        if(this.fatherRuleData.length){
          console.log(max);

          // return max;
          return this.fatherRuleData[index].symbolGroup[i].value;
        }else {
          return '≤' + max;
        }
      },
      blurHandle(colItem, index, i){
        // 重置当前输入项的错误状态
        colItem.validateError = false;
        colItem.validateErrorType = '';
        colItem.maxValue = null;
        
        // 非空验证
        if(colItem.value === ''){
          colItem.validateError = true;
          colItem.validateErrorType = 'empty';
        } else {
          // 负数验证
          if(parseFloat(colItem.value) < 0){
            colItem.validateError = true;
            colItem.validateErrorType = 'negative';
          } else {
            // 格式验证
            const centItem = this.SelfRuleData.find(item => item.symbolGroup.includes(colItem));
            const isCent = centItem ? centItem.mt4GroupNamme === 'Cent' : false;
            const isStockCrypto = colItem.name === 'Stock' || colItem.name === 'Crypto';
            
            let valid = true;
            if (isCent) {
              if (isStockCrypto) {
                // Cent 且是 Stock 或 Crypto：最多两位小数
                valid = /^[0-9]+(\.[0-9]{1,2})?$/.test(colItem.value);
              } else {
                // Cent 且不是 Stock 或 Crypto：最多四位小数
                valid = /^[0-9]+(\.[0-9]{1,4})?$/.test(colItem.value);
              }
            } else {
              if (isStockCrypto) {
                // 非 Cent 且是 Stock 或 Crypto：只能是整数
                valid = /^[0-9]+$/.test(colItem.value);
              } else {
                // 非 Cent 且不是 Stock 或 Crypto：最多一位小数
                valid = /^[0-9]+(\.[0-9]{1})?$/.test(colItem.value);
              }
            }
            
            if(!valid){
              colItem.validateError = true;
              colItem.validateErrorType = 'format';
            } else {
              // 佣金规则验证
              if(!this.fatherRuleData.length){
                if(colItem.value > colItem.max){
                  colItem.validateError = true;
                  colItem.validateErrorType = 'commission';
                  colItem.maxValue = colItem.max;
                }
              }else {
                // 编辑佣金规则
                if(parseFloat(colItem.value) > this.fatherRuleData[index].symbolGroup[i].value){
                  colItem.validateError = true;
                  colItem.validateErrorType = 'commission';
                  colItem.maxValue = this.fatherRuleData[index].symbolGroup[i].value;
                }
              }
            }
          }
        }
        
        // 强制重新渲染以显示错误提示
        this.$forceUpdate();
      },
      validateClass(colItem,index,i){
        if(colItem.validateError){
          return 'nopass';
        }
        if(!this.fatherRuleData.length){
          if(colItem.value > colItem.max){
            return 'nopass';
          }else {
            return '';
          }
        }else {
          if(colItem.value > this.fatherRuleData[index].symbolGroup[i].value){
            return 'nopass';
          }else {
            return '';
          }
        }
      },
      getErrorMessage(colItem,index){    
      if(colItem.validateErrorType === 'empty'){
        return this.$t('cannot_be_empty');
      } else if(colItem.validateErrorType === 'commission'){
        return this.$t('The_highest_can_be_set')  + ' '+ colItem.maxValue;
      } else if(colItem.validateErrorType === 'negative'){
        return this.$t('cannot_be_negative');
      } else {
        const isCent = this.SelfRuleData[index].mt4GroupNamme === 'Cent';
        const isStockCrypto = colItem.name === 'Stock' || colItem.name === 'Crypto';
        
        if (isCent) {
          if (isStockCrypto) {
            return this.$t('max_two_decimal_places');
          } else {
            return this.$t('max_four_decimal_places');
          }
        } else {
          if (isStockCrypto) {
            return this.$t('only_integers_allowed');
          } else {
            return this.$t('max_one_decimal_place');
          }
        }
      }
    },
      validateTable(){
        // 现在SelfRuleData没有数据所以报错了,到时候联调再看 todo
        let pass = getRuleValidateFlag(this.SelfRuleData,this.fatherRuleData,this);
        
        // 强制重新渲染组件，确保validateError标记生效
        this.$forceUpdate();
        
        if(!pass){
          return;
        }else {
          let copySelfRuleData = getHandleRuleData(this.SelfRuleData);
          this.$emit('submit',copySelfRuleData);
        }
      },
      getReadonlyText(item){
        if(item.max == -1){
          return '/'
        }
        return `${item.value}`;
      },
    }
  };
</script>
<style lang="scss">
  .rule-table-wrapper {
    width: 100%;
    overflow-x: hidden; // 禁止横向滚动
  }
  .rule-table-container {
    overflow-x: hidden; // 手机端禁止横向滚动
    margin: 0 -10px;
    padding: 0 10px;
    
    @media (max-width: 768px) {
      overflow-x: hidden !important;
    }
  }
  .rule-table {
    min-width: 768px;
    width: 100%;
    
    // 手机端去掉宽度和最小宽度限制
    @media (max-width: 768px) {
      min-width: auto !important; // 强制移除最小宽度
      width: auto !important;     // 强制移除宽度
    }
    
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      min-width: 80px;
      @media (max-width: 768px) {
        font-size: 12px;
        min-width: 70px;
      }
    }
    .el-form-item__content {
      line-height: 50px;
    }
    .nopass {
      .el-input__inner {
        color: red;
        border: 1px solid red;
      }
    }
    .el-col-7 {
      min-width: 120px;
      flex: 1 1 14.28571429%;
      @media (max-width: 768px) {
        min-width: 100px;
      }
    }
  }
</style>
<style scoped lang="scss">
  .rule-table {
    .table-title {
      margin-bottom: 10px;
    }
    .center {
      text-align: center;
    }
    
    // 手机端分模块从上往下排列
    @media (max-width: 768px) {
      // 隐藏表头
      .first-row {
        display: none !important; // 强制隐藏表头
      }
      
      // 每个账户类型作为一个模块
      .second-row {
        display: block !important;
        border: 1px solid #EBE9F1;
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 0;
        background-color: #fff;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        // 账户类型标题 - 模块头部
        .account-type-cell {
          display: block !important;
          width: 100% !important;
          background-color: #F3F2F7;
          font-weight: bold;
          padding: 12px 10px;
          text-align: center;
          border-bottom: 1px solid #EBE9F1;
          box-sizing: border-box;
          border-radius: 5px 5px 0 0;
        }
        
        // 数据单元格 - 从上往下排列
        .data-cell {
          display: flex !important;
          justify-content: space-between;
          align-items: center;
          padding: 10px 15px;
          border: none;
          border-bottom: 1px solid #f0f0f0;
          width: 100%;
          box-sizing: border-box;
          
          &:last-child {
            border-bottom: none;
          }
          
          // 在左侧添加标签
          &::before {
            content: attr(data-label);
            font-weight: 500;
            color: #5E5873;
            margin-right: 15px;
            white-space: nowrap;
            flex-shrink: 0;
          }
          
          .form-item {
            flex: 1;
            margin-bottom: 0;
            min-width: auto;
            width: 100%;
            max-width: 200px;
            
            .input-box {
              width: 100%;
            }
          }
        }
      }
    }
    
    .el-row{
      display:flex;
    }
    .col-box {
        min-height: 56px;
        min-width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #F0F0F0;
        border-top: none;
        border-right: none;
        flex:1;
        @media (max-width: 768px) {
          min-width: 100px;
        }
        &.header {
          background-color: #F3F2F7;
          border-right: none;
          border-left: none;
          border-bottom: none;
          font-weight: bold;
        }
        &.one-col {
          border-left: 1px solid #F0F0F0;
        }
        &.isfirst-row {
          border-top: 1px solid #F0F0F0;
        }
        &:not(:first-of-type){
          border-left: none;
        }
        &:last-of-type {
          border-right: 1px solid #F0F0F0;
        }
      .form-item {
        padding: 5px;
        margin-bottom: 10px;
        .suffix {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 5px;
          font-size: 12px;
          @media (max-width: 768px) {
            font-size: 11px;
          }
        }
        .error-message {
          font-size: 12px;
          text-align: left;
          color: red;
          z-index: 10;
          white-space: normal;
          max-width: 100%;
          line-height: 1.4;
          margin-top: 5px;
        }
      }
    }
    .no-data {
      text-align: center;
      font-size: 20px;
      padding: 40px 0;
    }
  }
</style>
